export const actionPlan = {
  unity: "{{idUnity}} - {{storeName}}",
  'areYouSureWantDeleteAllPlansSelected_one': '¿Estás seguro que deseas eliminar este plan de acción?',
  'areYouSureWantDeleteAllPlansSelected_other': '¿Estás seguro que deseas eliminar los planes de acción seleccionados?',
  'areYouSureWantDeleteThisPlanSelected': '¿Estás seguro que deseas deshacer este plan por generar?',
  toDeleteTheSelectedPlans: 'Al eliminar un plan, se borrará de tu lista y debes realizar nuevamente su configuración.',
  areYouSureWantUndoAllPlansSelected: '¿Estás seguro que deseas deshacer los planes seleccionados?',
  toUndoTheSelectedPlans: 'Al deshacer este plan, se eliminará de la lista y no podrá recuperarse.',
  typeCreation: 'Tipo de creación',
  typeCreationManual: 'Manual',
  typeCreationAutomatic: 'Automático',
  "goBack": "Regresar a la lista de planes de acción",
  "createActionPlan": "Crear plan de acción",
  "createPlan": "Crear plan",
  "actionPlanTitle": "Título",
  "actionPlanToGenerateTitle": "Plan de acción por generar",
  "instruction": "Instrucción",
  "unit": "Unidad",
  "storeManager": "Gerente de unidad",
  "assignedUserConfiguration": "Configuración del usuario asignado",
  "actionPlanInformation": "Información del plan de acción",
  "users": "Usuarios",
  "role": "Rol",
  "userType": "Tipo de usuario",
  "search": "Buscar",
  "filterModalTitle": "Filtros del usuario asignado",
  "filter": "Filtrar",
  "step1": "PASO 1",
  "step1Label": "Información básica",
  "step2": "PASO 2",
  "step2Label": "Selección de preguntas",
  "step3": "PASO 3",
  "step3Label": "Selección de evidencias",
  "step4": "PASO 4",
  "step4Label": "Notificaciones",
  "step2Placeholder": "Seleccione las preguntas que desea incluir en el plan de acción",
  "step3Placeholder": "Seleccione las evidencias que desea incluir en el plan de acción",
  "whoReceivesNotifications": "Configuración de notificaciones",
  "configureNotifications": "En caso que requiera notificar el plan de acción a otros usuarios, utilice este espacio para especificarlos.",
  "selectWhoReceives": "Selecciona quienes recibirán la notificación.",
  "enterExternalEmails": "Ingresa los correos de personas externas que también deben recibir la notificación.",
  "emailPlaceholder": "ejemplo@correo.com",
  "external": "Externo",
  "invalidEmail": "El correo electrónico no es válido",
  "duplicateEmail": "El correo electrónico ya fue agregado",
  "sendCopyTo": "Enviar copia a",
  "noRecipientsYet": "Aún no has agregado destinatarios",
  "triggerQuestion": "Pregunta que detona el plan",
  "selectedAnswer": "Respuesta seleccionada",
  "answer": "Respuesta",
  "paths_one": "{{count}} camino",
  "paths_other": "{{count}} caminos",
  "showMoreNodes": "Ver más",
  "showLessNodes": "Ver menos",
  "questions": "Preguntas",
  "evidences": "Evidencias",
  "expandAll": "Desplegar todos",
  "collapseAll": "Colapsar todos",
  "selectAll": "Seleccionar todos",
  "createActionPlanConfirm": "¿Deseas crear un Plan de Acción con los ítems seleccionados?",
  "createActionPlanConfirmDesc": "Se incluirán {{count}} ítems de preguntas provenientes del cuestionario {{questionnaire}}.",
  "validation": {
    "selectAtLeastOneUser": "Debe seleccionar al menos un usuario",
    "selectAtLeastOneQuestion": "Debe seleccionar al menos una pregunta",
    "selectAtLeastOneOption": "Debe seleccionar al menos una opción",
    "invalidEmails": "Uno o más correos tienen formato inválido"
  },
  "title": "Planes creados",
  "titleAutomatic": "Planes de acción automáticos",
  "undo": "Deshacer",
  "generateActionPlan": "Generar plan de acción",
  "viewDetail": "Ver detalle",
  byUsers: 'Por usuarios',
  solutionDate: "Tiempo máximo de solución: {{date}}",
  byStores: 'Por unidades',
  successDownloadReport: 'El reporte se descargó exitosamente.',
  errorDownloadReport: 'Ocurrió un error al descargar el reporte.',
  actionPlanResponse: 'Respuestas del plan',
  aprovers: 'Usuarios aprobadores',
  approveAssigned: 'Se reasignaron los usuarios exitosamente',
  emitBy: 'Emitida por',
  rejectBy: 'Rechazado por',
  aproveBy: 'Usuario aprobador',
  generatedBy: 'Usuario asignador',
  referencedStore: 'Unidad referenciada',
  userSolver: 'Usuario asignado',
  responseDetail: 'Detalle de respuesta',
  rejectMotive: 'Motivo de rechazo',
  evidenceList: 'Listado de evidencias',
  noActionPlan: 'Aún no se han recibido respuestas en este plan de acción',
  timeOut: "Han pasado {{time}} horas y no se han obtenido respuestas de los usuarios aprobadores",
  reassignActionPlan: 'Reasignar plan de acción',
  noAprovers: 'Aún no se han asignado usuarios aprobadores',
  "modal": {
    "title": "Por favor indique el motivo de su rechazo",
    "label": "Motivo del rechazo",
    "cancel": "¿Estás seguro que deseas cancelar este plan de acción?"
  },
  approverTitle: '¿Estás seguro que deseas que los usuarios seleccionados puedan aprobar este plan de acción?',
  approverNotSelecets: 'No hay usuarios seleccionados',
  approverDescription: '',
  tabs: {
    evidence: 'Evidencias',
    item: 'Items'
  },
  "actionPlanOf": {
    "stores": "Por unidades",
    "users": "Por usuarios"
  },
  "snackbar": {
    'selectAtLeastOnePlan': 'Debes seleccionar al menos un plan de acción para realizar esta acción',
    "cancel": {
      "success": "El plan de acción se cancelo exitosamente",
      "error": "Ocurrió un error al cancelar el plan de acción"
    },
    "approved": {
      "success": "El plan de acción se aprobó exitosamente",
      "error": "Ocurrió un error al aprobar el plan de acción"
    },
    "reject": {
      "success": "El plan de acción se rechazó exitosamente",
      "error": "Ocurrió un error al rechazar el plan de acción"
    },
    "delete": {
      "error": {
        "unique": "No se pudo eliminar el plan de acción.",
        "masive": "No se pudieron eliminar los planes de acción seleccionados."
      },
      "success": {
        "unique": "El plan de acción se eliminó correctamente.",
        "masive": "Los planes de acción seleccionados se eliminaron correctamente."
      }
    },
    "undo": {
      "error": "No se pudieron deshacer los planes seleccionados.",
      "success": "Los planes seleccionados se deshicieron correctamente."
    },
    "create": {
      "success": "Plan de acción creado con éxito"
    },
  },
  creationTypeLabel: 'Tipo de creación del plan de acción',
  creationType: {
    manual: 'Manual desde el módulo de planificación',
    manualQuestionnaire: 'Manual por ejecución de un cuestionario',
    automatic: 'Automático',
    manualLabel: 'Manual',
    manualByExecution: 'Manual por ejecución'
  },
  generateActionPlanAlert: 'Funcionalidad en desarrollo: Generar plan de acción',
  errorLoadingPlanInfo: 'Ocurrió un error al cargar la información del plan de acción.',
  errorCreatingActionPlan: 'Ocurrió un error al crear el plan de acción. Inténtalo nuevamente.',
  noAvailableUsers: 'No hay usuarios disponibles para asignar.',
  noEvidencesForQuestion: 'La pregunta seleccionada no tiene evidencias.',
  approversTitle: 'Usuario(s) aprobador(es)',
  questionsAndEvidences: 'Preguntas del cuestionario y evidencias',
  downloadEvidences: 'Descargar evidencias',
  sections: {
    items: 'Items',
    questions: 'Preguntas del cuestionario',
    questionnaireTitle: 'Cuestionario {{questionnaire}}',
    instructions: 'Instrucciones del plan',
    generalEvidences: 'Evidencias generales del plan',
    responses: 'Respuestas del plan'
  },
  requestDate: 'Fecha de solicitud',
  solutionDateLabel: 'Tiempo máximo de solución',
  solve: 'Resolver',
  solveActionPlan: 'Resolver plan de acción',
  tags: {
    timeRemaining: 'Tiempo restante',
    assignedUser: 'Usuario asignado',
    assigningUser: 'Usuario asignador',
    idUnity: 'ID - Unidad',
    days: 'Días',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    creationTypeLine1: 'Tipo de',
    creationTypeLine2: 'creación',
    gestionType: 'Tipo de gestión',
  },
  manualCreation: {
    title: 'Crear plan de acción',
    returnToList: 'Regresar al listado',
    step1: {
      title: 'Información básica del plan',
      subtitle: 'Ponle un nombre claro y describe qué debe hacer el usuario asignado.',
      titleLabel: 'Título',
      instructions: 'Instrucciones',
      charactersAvailable: 'caracteres disponibles',
      endDateLabel: 'Seleccione fecha y hora de finalización',
      sendEmailCopy: 'Enviar copia por correo electrónico',
    },
    whatIncludes: {
      title: '¿Qué incluirá este plan?',
      helper: '*Selecciona al menos una opción. Puedes combinar varias.',
      options: [
        {
          title: 'Items',
          description: 'Completa campos como ¿Qué?, ¿Cuándo?, ¿Cómo?, etc.',
        },
        {
          title: 'Vincular con cuestionario existente',
          description: 'Selecciona las preguntas para vincular al plan.',
        },
        {
          title: 'Evidencias',
          description: 'Adjunta fotos, videos, firmas, documentos o comentarios.',
        },
        {
          title: 'Evidencias del solucionador',
          description: 'Selecciona las evidencias para el solucionador.',
        },
      ],
    },
    steps: [
      { step: 'PASO 1', label: 'Información básica' },
      { step: 'PASO 2', label: 'Seleccionar usuarios' },
      { step: 'PASO 3', label: 'Notificaciones' },
    ],
    step2: {
      title: '¿Quién participará en este plan?',
      subtitle: 'Puedes asignar un solo usuario asignado responsable y varios aprobadores.',
      assignedUser: 'Usuario asignado',
      approvers: 'Usuarios aprobadores',
      searchPlaceholder: 'Buscar',
      selectAll: 'Seleccionar todo',
      filters: {
        assignedTitle: 'Filtros del usuario asignado',
        approversTitle: 'Filtros de aprobadores',
        unit: 'Unidad',
        userType: 'Tipo de usuario',
        role: 'Rol',
        area: 'Área',
        department: 'Departamento',
        filter: 'Filtrar',
      },
    },
    step3: {
      title: 'Configuración de notificaciones',
      subtitle: 'En caso que requiera notificar el plan de acción a otros usuarios, utilice este espacio para especificarlos.',
      selectWhoReceives: 'Selecciona quiénes recibirán la notificación.',
      enterExternalEmails: 'Ingresa los correos de personas externas que también deben recibir la notificación.',
    },
    confirmConfiguration: {
      title: '¿Está seguro que desea guardar esta configuración?',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
    confirmSave: {
      title: '¿Está seguro que desea generar este plan de acción?',
      description: 'Esta acción generará un plan de acción.',
    },
    clearConfiguration: {
      title: '¿Está seguro que desea descartar esta configuración?',
      description: 'Los ajustes realizados en esta sección se eliminarán y deberá volver a configurarlos.',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
    items: {
      configureTitle: 'Configurar Items',
      configureSubtitle: 'Selecciona y completa los items para el plan. También puedes escoger la opción de vincular un cuestionario existente.',
      panelTitle: 'Items',
      searchPlaceholder: 'Buscar',
      noItemSelected: 'No ha seleccionado un item',
      answerPlaceholder: 'Ingrese la respuesta *',
      back: 'Volver',
      saveAndBack: 'Guardar y volver',
      list: {
        what: '¿Qué?',
        where: '¿Dónde?',
        when: '¿Cuándo?',
        howMuch: '¿Cuánto?',
        why: '¿Porqué?',
        who: '¿Quién?',
        how: '¿Cómo?',
        observations: 'Observaciones',
      },
    },
    linkQuestionnaire: {
      configureTitle: 'Vincular con cuestionario existente',
      configureSubtitle: 'Selecciona el cuestionario junto con sus preguntas para asociarlas al plan de acción',
      selectQuestionnaireTitle: 'Seleccionar cuestionario',
      selectQuestionnaireSubtitle: 'Selecciona el cuestionario junto con sus preguntas para asociarlas al plan de acción',
      selectQuestionnaireLabel: 'Cuestionario',
      noQuestionnaireSelected: 'No ha seleccionado un cuestionario',
      questionsTitle: '¿Qué preguntas deseas ver?',
      allQuestions: 'Todas las preguntas',
      allQuestionsSubtitle: 'Ver las {{count}} preguntas del cuestionario completo',
      questionsWithActionPlan: 'Preguntas con plan de acción',
      questionsWithActionPlanSubtitle: 'Ver las preguntas que cuentan con plan de acción',
      selectQuestionsTitle: 'Selecciona las preguntas para el plan',
      searchPlaceholder: 'Buscar pregunta',
      selectAll: 'Seleccionar todas',
      clear: 'Limpiar',
      section: 'Sección 1',
      back: 'Volver',
      saveAndBack: 'Guardar y volver',
      errorLoadingQuestionnaires: 'Ocurrió un error al cargar los cuestionarios.',
      errorLoadingQuestions: 'Ocurrió un error al cargar las preguntas.',
      noQuestionsAvailable: 'No hay preguntas disponibles',
      noQuestionsWithActionPlan: 'No hay preguntas con plan de acción configurado',
      noQuestionsFound: 'No se encontraron preguntas',
    },
    evidences: {
      configureTitle: 'Configurar evidencias',
      configureSubtitle: 'Adjunte las evidencias necesarias para el plan de acción.',
      panelTitle: 'Evidencias',
      list: 'Lista',
      grid: 'Cuadrícula',
      dropzoneTitle: 'Seleccione un archivo o arrastre aquí',
      allowedFormats: 'Formatos permitidos: {{formats}}.',
      noInformation: 'No hay información',
      commentPlaceholder: 'Comentario',
      addComment: 'Agregar comentario',
      addSignature: 'Agregar firma',
      clearSignature: 'Limpiar',
      uploading: 'Subiendo...',
      uploadError: 'Error al subir el archivo',
      retry: 'Reintentar',
      back: 'Volver',
      saveAndBack: 'Guardar y volver',
      types: {
        image: 'Imágenes del dispositivo',
        video: 'Videos del dispositivo',
        sign: 'Firmas',
        document: 'Documentos',
        comment: 'Comentarios',
      },
    },
    solverEvidences: {
      configureTitle: 'Configurar evidencias del solucionador',
      configureSubtitle: 'Selecciona las evidencias y su configuración para el solucionador.',
      back: 'Volver',
      saveAndBack: 'Guardar y volver',
    },
  },
  solveActionPlan: {
    title: 'Resolver plan de acción',
    backToList: 'Regresar al listado',
    evidenceLoadTitle: 'Carga de evidencias',
    evidenceLoadSubtitle: 'Adjunta las evidencias configuradas para respaldar las respuestas registradas.',
    finalize: 'Finalizar',
    types: {
      image: 'Imágenes',
      camera: 'Imágenes del dispositivo',
      video: 'Videos',
      video_gallery: 'Galería de video',
      sign: 'Firmas',
      document: 'Documentos',
      comment: 'Comentarios',
    },
    noFilesAttached: 'No hay archivos adjuntos',
    errors: {
      maxSize: 'El archivo excede el tamaño máximo permitido',
      invalidType: 'Tipo de archivo no permitido',
      maxAmountExceeded_one: 'Solo se permite {{count}} archivo para este tipo de evidencia',
      maxAmountExceeded_other: 'Solo se permiten {{count}} archivos para este tipo de evidencia',
      invalidFilesDiscarded_one: 'Se descartó {{count}} archivo por no cumplir con el formato o tamaño permitido',
      invalidFilesDiscarded_other: 'Se descartaron {{count}} archivos por no cumplir con el formato o tamaño permitido',
    },
    confirmFinalize: {
      title: '¿Está seguro que desea enviar el plan de acción?',
      description: 'Registra un resumen claro de la solución implementada.',
      commentPlaceholder: 'Comentario de solución del plan de acción',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
    snackbar: {
      solveSuccess: 'El plan de acción se envió exitosamente',
      solveError: 'Ocurrió un error al resolver el plan de acción',
    },
  },
  errorCreatingPlan: 'Ocurrió un error al crear el plan de acción. Inténtalo nuevamente.',
}